<div class="chips" role="group" [attr.aria-label]="ariaLabel()">
  @for (option of options(); track option.key) {
    <forma-chips (click)="select.emit(option)">
      {{ option.label }}
    </forma-chips>
  }
</div>
